import { AbstractControl, ValidatorFn } from '@angular/forms';
import moment from 'moment';
import { environment } from '../environments/environment';

export class Util {
  static passwordPattern = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=\S*$)(?=.{8,})/;

  static passwordValidator(): ValidatorFn {
    return (control: AbstractControl): { [key: string]: unknown } | null => {
      const password = control.value;
      if (password && !Util.passwordPattern.test(password)) {
        return { invalidPassword: true };
      }
      return null;
    };
  }

  static passwordsMatch: ValidatorFn = (control: AbstractControl): { [key: string]: unknown } | null => {
    const password = control.get('password');
    const confirmPassword = control.get('confirmPassword');
    return password && confirmPassword && password.value !== confirmPassword.value ? { passwordsMismatch: true } : null;
  };

  static btcAmountValidator: ValidatorFn = (control: AbstractControl) => {
    const amount = control.value;
    if (amount !== null && amount < 0.00000001) {
      return { invalidAmount: true };
    }
    return null;
  };

  static formatDate(date: Date): string {
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear().toString().slice(-2);
    const hours = ('0' + date.getHours()).slice(-2);
    const minutes = ('0' + date.getMinutes()).slice(-2);
    const seconds = ('0' + date.getSeconds()).slice(-2);

    return `${day}/${month}/${year} ${hours}:${minutes}:${seconds}`;
  }

  static formatDateWithoutHours(date: Date): string {
    const day = ('0' + date.getDate()).slice(-2);
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const year = date.getFullYear().toString().slice(-2);

    return `${day}/${month}/${year}`;
  }

  static formatDocsDate(date: Date): string {
    const year = date.getFullYear();
    const month = ('0' + (date.getMonth() + 1)).slice(-2);
    const day = ('0' + date.getDate()).slice(-2);

    return `${year}-${month}-${day}`;
  }

  static getLocaleName(lang: string): string {
    let locale = 'ru-RU';
    switch (lang) {
      case 'en':
        locale = 'en-US';
        break;
      case 'kz':
        locale = 'kk-KZ';
        break;
    }
    return locale;
  }

  static getDomainForCookie(): string {
    return environment.name === 'local' ? 'localhost' : '.wemine.tech';
  }

  static convertTimestampToDate(timestamp: number) {
    return (moment as any).unix(timestamp).toDate();
  }

  static convertDateToTimestamp(timestamp: number, type: 'startOfDay' | 'endOfDay') {
    switch (type) {
      case 'startOfDay':
        return (moment as any)(timestamp).startOf('day').unix();
        break;
      case 'endOfDay':
        return (moment as any)(timestamp).endOf('day').unix();
        break;
      default:
        return false;
        break;
    }
  }
}
